import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import MaterialTable from "@material-table/core";
import { Container, Row, Col } from "reactstrap";
import moment from "moment";
import DateRangeIcon from "@mui/icons-material/DateRange";
import TodayIcon from "@mui/icons-material/Today";
import DescriptionIcon from "@mui/icons-material/Description";
import Counter from "../components/dashboard/counter";
import { setActiveMenu } from "../store/actions";
import Dashboard from "../store/actions/dashboard";
import { history } from "../utils";

const Index = ({ onSetActiveMenu, dashboard }) => {
  const dispatch = useDispatch();
  const moveToTransaction = () => {
    onSetActiveMenu("Transaksi");
    history.push("/transaksi");
  };

  const moveToSoquo = () => {
    onSetActiveMenu("SO/QUO");
    history.push("/so-quo");
  };

  useEffect(() => {
    dispatch(Dashboard.get());
  }, []);

  let data = {};

  if (dashboard?.data?.data?.data) {
    const dashboardData = dashboard.data.data.data;
    data.month_total_order = dashboardData.month_total_order;
    data.day_total_order = dashboardData.day_total_order;
    data.month_total_soquo = dashboardData.month_total_soquo;
    data.latest_order = dashboardData.latest_order.data.slice(0, 5);
    data.latest_soquo = dashboardData.latest_soquo.data.slice(0, 5);
  }
  const latestOrderData = data?.latest_order
    ? data.latest_order.map((item, idx) => ({
      no: idx + 1,
      transaction_date: item.created_at,
      customer_name: item.customer_name,
      order_qty: item.total_qty_kg,
      status: item.status,
    }))
    : [];

  const latestSoquoData = data?.latest_soquo
    ? data.latest_soquo.map((item, idx) => ({
      no: idx + 1,
      customer_name: item.customer_name,
    }))
    : [];

  return (
    <Container className="p-0">
      <h1 className="text-title content-title">Dashboard</h1>
      <Row className="m-0 d-flex justify-content-between dashboard-content">
        <Col className="pl-0" lg={4}>
          <Counter
            label="Order Bulan Ini"
            icon={DateRangeIcon}
            value={data?.month_total_order}
          />
        </Col>
        <Col className="pl-0" lg={4}>
          <Counter
            label="Order Hari Ini"
            icon={TodayIcon}
            value={data?.day_total_order}
          />
        </Col>
        <Col className="pl-0" lg={4}>
          <Counter
            label="Pengajuan SO/QUO"
            icon={DescriptionIcon}
            value={data?.month_total_soquo}
          />
        </Col>
      </Row>
      <Row className="m-0 d-flex justify-content-between">
        <Col lg={8} className="pl-0 pb-3">
          <Row className="m-0 justify-content-between">
            <h2 className="dashboard-section-title">
              Daftar Pesanan Terakhir
            </h2>
            <button
              type="button"
              className="dashboard-link mb-3 align-self-center"
              onClick={moveToTransaction}
            >
              Lihat Semua Order
            </button>
          </Row>
          <MaterialTable
            columns={[
              {
                title: "No",
                field: "no",
                width: 40,
              },
              {
                title: "Tanggal Transaksi",
                render: ({ transaction_date }) => {
                  return transaction_date
                    ? moment(transaction_date).format("DD MMM YYYY")
                    : "-";
                },
              },
              {
                title: "Nama Customer",
                field: "customer_name",
              },
              {
                title: "Jumlah Order",
                render: ({ order_qty }) => {
                  order_qty = order_qty
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
                  return `${order_qty} Kg`;
                },
              },
              {
                title: "Status",
                render: ({ status }) => {
                  return status === 0
                    ? "Draft"
                    : status === 1
                      ? "BARU"
                      : status === 2
                        ? "DIPROSES"
                        : status === 3
                          ? "DIKIRIM"
                          : "SELESAI";
                },
              },
            ]}
            data={latestOrderData}
            options={{
              paging: false,
              showTitle: false,
              search: false,
              sorting: false,
              headerStyle: {
                backgroundColor: "#fff",
                fontWeight: "bold",
                fontSize: 12,
                padding: "8px 6px",
              },
              cellStyle: {
                height: 50,
                fontSize: 12,
                padding: "8px 6px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: "Tidak ada data",
              },
            }}
            components={{
              Toolbar: () => <div />,
            }}
          />
        </Col>
        <Col lg={4} className="pl-0">
          <Row className="m-0 justify-content-between">
            <h2 className="dashboard-section-title">
              Daftar Pengajuan SO/QUO
            </h2>
            <button
              type="button"
              className="dashboard-link mb-3 align-self-center"
              onClick={moveToSoquo}
            >
              Selengkapnya
            </button>
          </Row>
          <MaterialTable
            columns={[
              {
                title: "No",
                field: "no",
                width: 40,
              },
              {
                title: "Nama Customer",
                field: "customer_name",
              },
            ]}
            data={latestSoquoData}
            options={{
              paging: false,
              showTitle: false,
              search: false,
              sorting: false,
              headerStyle: {
                backgroundColor: "#fff",
                fontWeight: "bold",
                fontSize: 12,
                padding: "8px 6px",
              },
              cellStyle: {
                height: 50,
                fontSize: 12,
                padding: "8px 6px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: "Tidak ada data",
              },
            }}
            components={{
              Toolbar: () => <div />,
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = ({ global, dashboard }) => {
  return { global, dashboard };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetActiveMenu: (menu) => dispatch(setActiveMenu(menu)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
